module.exports = __webpack_public_path__ + "img/financing-of-goib.edc73167.png";